export default __webpack_public_path__ + "static/media/EAH-AZ60 1.d68e85f5.jpg";